import { StringMap } from '../utils/TypeDefinitions';

export async function setupAML(amlInitData: StringMap): Promise<void> {
	await window.setupAML(amlInitData);
}

export async function setupSentry(sentryInitData: StringMap): Promise<void> {
	await window.setupSentry(sentryInitData);
}

export async function setupAccountConfig(
	accountConfigInitData: StringMap
): Promise<void> {
	await window.setupAccountConfig(accountConfigInitData);
}
